var heading_default = {
  "fontElementMap": "pvC70",
  "elementSpacing": "LwHFu",
  "headerOne": "jRzXo LwHFu",
  "headerTwo": "oQ7wS LwHFu",
  "headerThree": "qtPmu LwHFu",
  "headerFour": "g5kj0 LwHFu",
  "headerFive": "lPHkO LwHFu",
  "headerSix": "JVott LwHFu",
  "child": "Mvsya"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
